document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('product-modal');
  if (!modal) return;

  let index = 0;
  let initialized = false;

  let nextBtn = null;
  let prevBtn = null;

  const observer = new MutationObserver(() => {
    const isOpen =
      modal.hasAttribute('open') ||
      modal.classList.contains('active');

    if (isOpen) {
      setTimeout(init, 120);
    } else {
      cleanup();
      initialized = false;
    }
  });

  observer.observe(modal, {
    attributes: true,
    attributeFilter: ['open', 'class']
  });

  function init() {
    if (initialized) return;
    initialized = true;

    const track = modal.querySelector('.product-media-modal__content');
    if (!track) return;

    const items = [...track.querySelectorAll('[data-media-id]')];
    if (!items.length) return;

    track.style.scrollBehavior = "smooth";

    // prevent duplicate buttons
    if (modal.querySelector('.popup-next')) return;

    const next = document.createElement('button');
    const prev = document.createElement('button');

    next.className = 'popup-next';
    prev.className = 'popup-prev';

    next.innerHTML = '›';
    prev.innerHTML = '‹';

    Object.assign(next.style, btnStyle('right'));
    Object.assign(prev.style, btnStyle('left'));

    nextBtn = next;
    prevBtn = prev;

    document.body.appendChild(nextBtn);
    document.body.appendChild(prevBtn);

    function go() {
      items[index].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }

    // NEXT
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();

      index = (index + 1) % items.length;
      go();
    });

    // PREV
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();

      index = (index - 1 + items.length) % items.length;
      go();
    });

    // sync scroll index
    track.addEventListener('scroll', () => {
      let closest = 0;
      let min = Infinity;

      items.forEach((el, i) => {
        const d = Math.abs(el.getBoundingClientRect().left);
        if (d < min) {
          min = d;
          closest = i;
        }
      });

      index = closest;
    });

    // mobile tuning
    if (isMobile()) {
      nextBtn.style.width = "38px";
      nextBtn.style.height = "38px";
      prevBtn.style.width = "38px";
      prevBtn.style.height = "38px";

      nextBtn.style.opacity = "0.95";
      prevBtn.style.opacity = "0.95";
    }
  }

  function cleanup() {
    if (nextBtn) {
      nextBtn.remove();
      nextBtn = null;
    }

    if (prevBtn) {
      prevBtn.remove();
      prevBtn = null;
    }
  }

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function btnStyle(side) {
    return {
      position: 'fixed',
      top: '50%',
      transform: 'translateY(-50%)',
      [side]: '20px',
      zIndex: 9999999,
      background: 'rgba(0,0,0,0.6)',
      color: '#fff',
      border: 'none',
      fontSize: '26px',
      width: '42px',
      height: '42px',
      borderRadius: '50%',
      cursor: 'pointer',
      userSelect: 'none',
      pointerEvents: 'auto'
    };
  }

  window.addEventListener('resize', () => {
    if (!nextBtn || !prevBtn) return;

    if (window.innerWidth <= 768) {
      nextBtn.style.width = "38px";
      nextBtn.style.height = "38px";
      prevBtn.style.width = "38px";
      prevBtn.style.height = "38px";
    }
  });
});